import { Control, FieldErrors } from 'react-hook-form';
import { twJoin } from 'tailwind-merge';

import { ConfirmationCheckbox } from './ConfirmationCheckbox';

import { Box } from '@/components/ui/box';
import { InquiryDraftFormData } from '@/hooks/useInquiryForm';

interface NoPHIFieldProps {
  control: Control<InquiryDraftFormData>;
  errors: FieldErrors<InquiryDraftFormData>;
  isDisabled: boolean;
  hasFiles: boolean;
  className?: string;
}

/**
 * No PHI Confirmation Field Component
 *
 * @overview
 * Checkbox for users to confirm their attachments contain no Protected Health Information.
 * Required when files are present.
 *
 * @behavior
 * - Shows only when files are present (conditional rendering handled by parent)
 * - Required validation when hasFiles is true
 * - Clear messaging about PHI restrictions
 * - Error display for validation issues
 */
export function NoPHIField({
  control,
  errors,
  isDisabled,
  hasFiles,
  className = '',
}: NoPHIFieldProps) {
  if (!hasFiles) {
    return null;
  }

  return (
    <Box className={twJoin('mb-4 web:mb-0', className)}>
      <ConfirmationCheckbox
        control={control}
        errors={errors}
        fieldName="attachmentNoPHI"
        variant="phi"
        isDisabled={isDisabled}
      />
    </Box>
  );
}
